import { runClientComponent } from '../../_common/client/client-component-runner';
import { ComplaintToolComponent } from './complaint-tool.component';

runClientComponent({ ComplaintToolComponent: ComplaintToolComponent });
